import type AnalyticsUtmParams from '~/contracts/common/AnalyticsUtmParams';

const allowedUtms = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

export default function getAnalyticsUtmParams(
  utmParams: Record<string, string>
): AnalyticsUtmParams {
  return allowedUtms.reduce<Record<string, string>>(
    (filteredUtmParams, key) => {
      if (utmParams[key]) {
        filteredUtmParams[key] = utmParams[key];
      }

      return filteredUtmParams;
    },
    {}
  );
}
